module.exports = __webpack_public_path__ + "static/media/wire3.0c2a3c9f.png";